export const defaultFont = "proxima-nova, sans-serif";

/*
  Each row height is 8vh, so there will be 12.5 rows (12.5 * 8 = 100)
*/
export const portraitRowHeight = "8vh";

export const disableIconOpacity = 0.5;

export const portrait = {
  topPanel: {
    height: `calc(calc(0.25 * ${portraitRowHeight}) + ${portraitRowHeight})`, // ticker + header
    width: "100%",
    ticker: {
      height: `calc(0.25 * ${portraitRowHeight})`,
      width: "100%"
    },
    header: {
      top: `calc(0.25 * ${portraitRowHeight})`, // Note : This is ticker height
      height: portraitRowHeight,
      width: "100%",
      icon: {
        height: `calc(0.5 * ${portraitRowHeight})`,
        width: `calc(0.5 * ${portraitRowHeight})`
      }
    }
  },
  middlePanel: {
    // The 1px is the gap that is appears in the large phones like iPhone 8 and iPhone X, Samsung 8, etc.
    height: `calc(100vh - ${portraitRowHeight} + 1px)`,
    bottom: `calc(${portraitRowHeight} + 0.3 * ${portraitRowHeight})`, // Control + Footer
    width: "100%",
    navigation: {
      height: portraitRowHeight,
      width: "100%",
      icon: {
        height: `calc(0.5 * ${portraitRowHeight})`,
        width: "auto"
      }
    },
    footer: {
      icon: {
        height: "1.4em",
        width: "1.4em"
      }
    }
  },

  bottomPanel: {
    height: `calc(${portraitRowHeight} * 2 + calc(0.3 * ${portraitRowHeight}))`, // control + display + footer
    control: {
      height: portraitRowHeight,
      icon: {
        height: `calc(0.5 * ${portraitRowHeight})`,
        width: "auto"
      }
    },
    display: {
      height: portraitRowHeight
    },
    footer: {
      height: `calc(0.3 * ${portraitRowHeight})`
    }
  }
};

export const landscape = {
  topPanel: {
    width: "100%"
  },
  sidePanel: {
    width: "2.4em",
    icon: {
      height: "1.4em",
      width: "1.4em"
    }
  },
  bottomPanel: {
    height: "10vh",
    display: {
      height: "60%"
    },
    footer: {
      height: "40%"
    }
  }
};

export const fontSize = {
  xxs: ".47em",
  xs: ".6em",
  s: ".9em",
  m: "1em",
  l: "1.2em",
  xl: "1.4em",
  xxl: "1.6em",
  xxxl: "1.8em"
};
